<template>
    <div class="d-inline-block">
        <div class="d-flex">
            <div>
                {{ '*'.repeat(length) }}
            </div>
            <div v-if="copyable">
                <button class="btn btn-xs" @click="copyTextToClipboard(value)">
                    <i class="fas fa-copy"/>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import {copyTextToClipboard} from '@composables/clipboard';

export default {
    props: {
        value: String,
        copyable: {
            type: Boolean,
            default: true,
        },
        length: {
            type: Number,
            default: 10,
        },
    },

    methods: {
        copyTextToClipboard,
    },
};
</script>
